import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleplayRoutingModule } from './roleplay-routing.module';
import { CoreModule } from 'core/core.module';
import { CustomizationListComponent } from './components/customization-list/customization-list.component';
import { CustomizationDetailComponent } from './components/customization-detail/customization-detail.component';
import { RoleplaySubscriptionListComponent } from './components/roleplay-subscription-list/roleplay-subscription-list.component';

@NgModule({
  imports: [CommonModule, CoreModule, RoleplayRoutingModule],
  declarations: [CustomizationListComponent, CustomizationDetailComponent, RoleplaySubscriptionListComponent],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RoleplayModule {}
